import { isoStringToDate } from '../Helpers';
import { DEVICE_STATUS } from '../constants/statuses';
import { LPR_DEVICE_TYPE } from '../constants/deviceTypes';

export const calculateDeviceStatus = device => {
    const currentTime = new Date();

    // LPR devices have no CA4K badge, so `has_ca4k_device` doesn't describe a sync state for them.
    // Their status is purely date-driven (never "Sync Needed"/"Invited").
    if (device.device_type === LPR_DEVICE_TYPE) {
        if (device.activate_at && isoStringToDate(device.activate_at) > currentTime) {
            return DEVICE_STATUS.INACTIVE;
        }
        if (device.expires_at && isoStringToDate(device.expires_at) < currentTime) {
            return DEVICE_STATUS.DISABLED;
        }
        return DEVICE_STATUS.ENABLED;
    }

    if (!device.has_ca4k_device) {
        if (device.owner?.uid) {
            return DEVICE_STATUS.SYNCNEEDED;
        } else {
            return DEVICE_STATUS.INVITED;
        }
    }

    if (device.activate_at && isoStringToDate(device.activate_at) > currentTime) {
        return DEVICE_STATUS.INACTIVE;
    }

    if (device.expires_at && isoStringToDate(device.expires_at) < currentTime) {
        return DEVICE_STATUS.DISABLED;
    }

    return DEVICE_STATUS.ENABLED;
};
